var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-graphs-section"},[_c('trend-line-report',{ref:"trends",attrs:{"error":_vm.trends.error,"graphData":_vm.trends.data,"wrapperWidth":_vm.trends.width},on:{"loadGraphData":_vm.loadGraphData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }